/* OhMySmile theme JS — réplique des interactions du site Lovable */
(function () {
  'use strict';

  /* ---------- Scroll d'ancres fiable (RAF, insensible aux animations) ---------- */
  document.documentElement.style.scrollBehavior = 'auto';
  function smoothScrollTo(targetY) {
    var startY = window.scrollY;
    var diff = targetY - startY;
    var dur = Math.min(900, Math.max(350, Math.abs(diff) * 0.35));
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var ease = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, startY + diff * ease);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function scrollToHash(hash) {
    var id = hash.replace(/^#/, '');
    var el = document.getElementById(id);
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.scrollY - 70; /* offset nav sticky */
    window.scrollTo(0, y); /* saut direct fiable */
    if (document.visibilityState === 'visible') smoothScrollTo(y); /* lissage si possible */
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    var path = href.slice(0, hashIndex);
    var samePage = path === '' || path === location.pathname || (path === '/' && location.pathname === '/');
    if (!samePage) return;
    if (scrollToHash(href.slice(hashIndex))) {
      e.preventDefault();
      history.pushState(null, '', href.slice(hashIndex));
    }
  });
  if (location.hash) {
    setTimeout(function () { scrollToHash(location.hash); }, 150);
  }

  /* ---------- Menu mobile ---------- */
  var menuBtn = document.querySelector('[data-oms-menu-btn]');
  var menuPanel = document.querySelector('[data-oms-menu]');
  if (menuBtn && menuPanel) {
    menuBtn.addEventListener('click', function () {
      menuPanel.classList.toggle('open');
    });
    menuPanel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menuPanel.classList.remove('open'); });
    });
  }

  /* ---------- Accordéons ---------- */
  document.querySelectorAll('[data-oms-accordion]').forEach(function (group) {
    var items = group.querySelectorAll('[data-oms-acc-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-oms-acc-btn]');
      var content = item.querySelector('[data-oms-acc-content]');
      if (!btn || !content) return;
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-state') === 'open';
        items.forEach(function (other) {
          other.setAttribute('data-state', 'closed');
          var b = other.querySelector('[data-oms-acc-btn]');
          var c = other.querySelector('[data-oms-acc-content]');
          if (b) { b.setAttribute('data-state', 'closed'); b.setAttribute('aria-expanded', 'false'); }
          if (c) { c.hidden = true; }
        });
        if (!isOpen) {
          item.setAttribute('data-state', 'open');
          btn.setAttribute('data-state', 'open');
          btn.setAttribute('aria-expanded', 'true');
          content.hidden = false;
        }
      });
    });
  });

  /* ---------- Galerie produit (desktop) ---------- */
  var mainImg = document.querySelector('[data-oms-main-img]');
  document.querySelectorAll('[data-oms-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      var img = thumb.querySelector('img');
      mainImg.src = img.src;
      document.querySelectorAll('[data-oms-thumb]').forEach(function (t) {
        t.classList.remove('border-accent', 'shadow-card');
        t.classList.add('border-border', 'opacity-60');
      });
      thumb.classList.add('border-accent', 'shadow-card');
      thumb.classList.remove('border-border', 'opacity-60');
    });
  });

  /* ---------- Galerie mobile : dots ---------- */
  var mScroll = document.querySelector('[data-oms-mgallery]');
  var dots = document.querySelectorAll('[data-oms-dot]');
  if (mScroll && dots.length) {
    mScroll.addEventListener('scroll', function () {
      var idx = Math.round(mScroll.scrollLeft / mScroll.clientWidth);
      dots.forEach(function (d, i) {
        d.className = 'h-2 rounded-full transition-all ' + (i === idx ? 'w-5 bg-accent' : 'w-2 bg-muted-foreground/30');
      });
    }, { passive: true });
  }

  /* ---------- Flèches des galeries de l'accueil (12/09/2026) ----------
     La galerie mobile n'avait que des points, et ils n'étaient pas cliquables :
     pour atteindre la 7e image il fallait deviner le balayage. On ajoute deux
     flèches, on rend les points cliquables, et on masque la flèche en bout de
     course plutôt que de la griser. */
  function omsFlechesMobile() {
    var sc = document.querySelector('[data-oms-mgallery]');
    var p = document.querySelector('[data-oms-mprev]');
    var n = document.querySelector('[data-oms-mnext]');
    if (!sc || !p || !n) return;
    function etat() {
      var max = sc.scrollWidth - sc.clientWidth - 2;
      p.disabled = sc.scrollLeft <= 2;
      n.disabled = sc.scrollLeft >= max;
    }
    function va(d) {
      /* 🔴 Défilement INSTANTANÉ, et c'est voulu. Deux tentatives ont échoué au banc :
         `scrollBy({behavior:'smooth'})` ne déplace rien quand les frames d'animation
         sont gelées, et poser `style.scrollBehavior='smooth'` avant d'assigner rend
         l'assignation animée — donc gelée aussi, mesuré : scrollLeft restait à 0 sur
         cette galerie à `snap-mandatory`. Une assignation nue atterrit toujours, et le
         snap CSS donne de toute façon l'impression d'un geste voulu. */
      sc.scrollLeft += d * sc.clientWidth;
      setTimeout(etat, 420);
    }
    p.addEventListener('click', function () { va(-1); });
    n.addEventListener('click', function () { va(1); });
    sc.addEventListener('scroll', etat, { passive: true });
    document.querySelectorAll('[data-oms-dot]').forEach(function (d, i) {
      d.addEventListener('click', function () {
        sc.scrollLeft = i * sc.clientWidth;
      });
    });
    etat();
  }

  /* En desktop l'image principale change au clic d'une vignette. Les flèches ne
     dupliquent pas cette logique : elles cliquent la vignette cible, ce qui garde
     une seule source de vérité, et font défiler la bande pour la garder visible. */
  function omsFlechesDesktop() {
    var p = document.querySelector('[data-oms-dprev]');
    var n = document.querySelector('[data-oms-dnext]');
    var th = document.querySelectorAll('[data-oms-thumb]');
    if (!p || !n || !th.length) return;
    var cur = 0;
    function etat() { p.disabled = (cur === 0); n.disabled = (cur === th.length - 1); }
    function va(d) {
      var i = cur + d;
      if (i < 0 || i >= th.length) return;
      cur = i;
      th[i].click();
      var bande = th[i].parentElement;
      if (bande) {
        var b = th[i].getBoundingClientRect(), z = bande.getBoundingClientRect();
        if (b.left < z.left + 1 || b.right > z.right - 1) {
          bande.scrollLeft = th[i].offsetLeft - (z.width - b.width) / 2;
        }
      }
      etat();
    }
    th.forEach(function (t, i) { t.addEventListener('click', function () { cur = i; etat(); }); });
    p.addEventListener('click', function () { va(-1); });
    n.addEventListener('click', function () { va(1); });
    etat();
  }
  omsFlechesMobile();
  omsFlechesDesktop();

  /* ---------- Packs / variantes ---------- */
  var PACKS = window.OMS_PACKS || [];
  var current = 1; /* Duo par défaut */
  var atcBtn = document.querySelector('[data-oms-atc]');
  var atcLabel = document.querySelector('[data-oms-atc-label]');

  function selectPack(i) {
    current = i;
    document.querySelectorAll('[data-oms-pack]').forEach(function (card, j) {
      card.classList.remove('border-[#7B4FD4]', 'bg-[#F5F0FF]', 'border-border', 'bg-[#F8F8F8]', 'bg-card');
      if (j === i) {
        card.classList.add('border-[#7B4FD4]', 'bg-[#F5F0FF]');
      } else {
        card.classList.add('border-border', j === 0 ? 'bg-[#F8F8F8]' : 'bg-card');
      }
    });
    if (atcLabel && PACKS[i]) atcLabel.textContent = '🛒 AJOUTER · ' + PACKS[i].price;
  }
  document.querySelectorAll('[data-oms-pack]').forEach(function (card, i) {
    card.addEventListener('click', function () { selectPack(i); });
  });

  /* ---------- Teinte ---------- */
  var TEINTES = [
    { label: 'A1', reco: 0, txt: 'Parfait pour entretenir votre teinte naturelle.' },
    { label: 'A2', reco: 1, txt: 'Recommandé pour raviver l’éclat en 14 jours.' },
    { label: 'A3', reco: 1, txt: 'Recommandé pour corriger votre teinte en 14 jours.' },
    { label: 'B1', reco: 2, txt: 'Recommandé : le rituel complet de 3 mois pour installer le résultat.' },
    { label: 'B2', reco: 2, txt: 'Recommandé : le rituel complet de 3 mois pour installer le résultat.' }
  ];
  var range = document.querySelector('[data-oms-range]');
  var recoName = document.querySelector('[data-oms-reco-name]');
  var recoPrice = document.querySelector('[data-oms-reco-price]');
  var recoTxt = document.querySelector('[data-oms-reco-txt]');

  function selectTeinte(i) {
    document.querySelectorAll('[data-oms-teinte]').forEach(function (b, j) {
      var dot = b.querySelector('span:first-child');
      var lab = b.querySelector('span:last-child');
      if (j === i) {
        b.classList.add('scale-105'); b.classList.remove('opacity-60');
        dot.classList.add('border-accent', 'shadow-md'); dot.classList.remove('border-border');
        lab.classList.add('text-accent'); lab.classList.remove('text-muted-foreground');
      } else {
        b.classList.remove('scale-105'); b.classList.add('opacity-60');
        dot.classList.remove('border-accent', 'shadow-md'); dot.classList.add('border-border');
        lab.classList.remove('text-accent'); lab.classList.add('text-muted-foreground');
      }
    });
    if (range) range.value = i;
    var t = TEINTES[i]; var p = PACKS[t.reco];
    if (recoName && p) recoName.textContent = p.name;
    if (recoPrice && p) recoPrice.innerHTML = p.price + (p.compare ? '<span class="text-[11px] md:text-xs text-muted-foreground line-through ml-1.5 font-normal">' + p.compare + '</span>' : '');
    if (recoTxt) recoTxt.textContent = t.txt;
    var seeBtn = document.querySelector('[data-oms-reco-see]');
    if (seeBtn) seeBtn.onclick = function () { selectPack(t.reco); };
  }
  document.querySelectorAll('[data-oms-teinte]').forEach(function (b, i) {
    b.addEventListener('click', function () { selectTeinte(i); });
  });
  if (range) range.addEventListener('input', function () { selectTeinte(parseInt(range.value, 10)); });

  /* ---------- Tiroir panier ---------- */
  var META = window.OMS_CART_META || { threshold: 4990, variants: {} };
  var drawer = document.querySelector('[data-oms-cart-drawer]');
  var overlay = document.querySelector('[data-oms-cart-overlay]');
  var itemsBox = document.querySelector('[data-oms-cart-items]');
  /* `shipMsg` et `shipBar` ont disparu le 12/09/2026 : la barre de port a été
     remplacée par la jauge des 3 paliers, rendue par `renderJauge`. Garder les deux
     variables aurait laissé du code mort qui interroge à la prochaine lecture. */
  var totalEl = document.querySelector('[data-oms-cart-total]');
  var compareEl = document.querySelector('[data-oms-cart-compare]');
  var countBadge = document.querySelector('[data-oms-cart-count]');

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0\u20AC';
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.classList.add('oms-cart-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.classList.remove('oms-cart-open');
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  var closeBtn = document.querySelector('[data-oms-cart-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ═══════════ MOTEUR D'OFFRES DU TIROIR — 12/09/2026 ═══════════
     🔴 LE DÉFAUT CORRIGÉ ICI, mesuré en ligne : le cadeau se testait sur la présence
     de la VARIANTE Trio. Un panier « Duo + 1 flacon en plus » valait donc 49,90 € et
     3 flacons, exactement le Trio, mais ne déclenchait aucun racleur — et le bandeau
     invitait encore à « passer au Trio ». On compte désormais les FLACONS, pas les
     variantes : plus aucun chemin ne peut atteindre 3 flacons sans le cadeau. */
  function nbFlacons(cart) {
    var t = META.flacons || {};
    return cart.items.reduce(function (n, it) {
      return n + (t[String(it.variant_id)] || 0) * it.quantity;
    }, 0);
  }
  function aRacleurPaye(cart) {
    var r = META.ids && META.ids.racleur;
    return !!r && cart.items.some(function (it) { return String(it.variant_id) === String(r); });
  }
  function cadeauAcquis(cart) { return nbFlacons(cart) >= (META.seuilCadeau || 3); }

  /* Échanger une variante suppose de savoir LAQUELLE remplacer. On ne le fait que si
     le panier contient exactement une ligne de pack, en quantité 1. Sinon on retombe
     sur l'ajout d'un flacon à 10 €, qui est juste dans tous les cas. */
  function lignePackUnique(cart) {
    var ids = META.ids || {};
    var packs = [String(ids.decouverte), String(ids.duo), String(ids.trio)];
    var t = cart.items.filter(function (it) { return packs.indexOf(String(it.variant_id)) !== -1; });
    return (t.length === 1 && t[0].quantity === 1) ? t[0] : null;
  }

  function valeurPercue(cart) {
    var v = nbFlacons(cart) * (META.prixUnitaire || 2990);
    if (cadeauAcquis(cart) || aRacleurPaye(cart)) v += (META.valeurRacleur || 1490);
    return v;
  }

  function renderJauge(cart) {
    var box = document.querySelector('[data-oms-jauge]');
    if (!box) return;
    if (cart.item_count === 0) { box.hidden = true; box.innerHTML = ''; return; }
    var seuil = META.seuilCadeau || 3, n = nbFlacons(cart), plein = cadeauAcquis(cart);
    var eco = valeurPercue(cart) - cart.total_price;
    var segs = '';
    for (var i = 1; i <= seuil; i++) {
      segs += '<div class="omsj-seg' + (n >= i ? (plein ? ' on gift' : ' on') : '') + '"></div>';
    }
    var msg;
    if (plein) msg = '<b>Racleur débloqué.</b> Il part avec votre colis.';
    else if (seuil - n === 1) msg = 'Il ne vous manque qu’<b>un flacon</b> pour débloquer le racleur.';
    else msg = 'Encore <b>' + (seuil - n) + ' flacons</b> et le racleur vous est offert.';
    box.innerHTML =
      '<div class="omsj-top"><span class="omsj-lab">Votre cure</span>' +
      (eco > 0 ? '<span class="omsj-eco' + (plein ? ' is-max' : '') + '">vous économisez ' + euros(eco) + '</span>' : '') +
      '</div><div class="omsj-bar">' + segs + '</div>' +
      '<div class="omsj-steps"><span>1 mois</span><span>2 mois</span><span>🎁 racleur</span></div>' +
      '<p class="omsj-msg">' + msg + '</p>';
    box.hidden = false;
  }

  function carteOffre(o) {
    var img = o.img || META.imgFlacon || '';
    return '<div class="omso' + (o.hero ? ' is-hero' : '') + '">' +
      '<p class="omso-kick">' + o.kick + '</p>' +
      '<div class="omso-row"><img src="' + img + '" alt="">' +
      '<div class="omso-txt"><p class="omso-t">' + o.titre + '</p>' +
      '<p class="omso-s">' + o.sous + '</p>' +
      '<div class="omso-p"><span class="now">' + o.prix + '</span>' +
      (o.barre ? '<span class="was">' + o.barre + '</span>' : '') +
      (o.eco ? '<span class="eco">' + o.eco + '</span>' : '') +
      '</div></div>' +
      '<button type="button" class="omso-btn" data-oms-act="' + o.act + '" aria-label="' + o.aria + '">Ajouter</button>' +
      '</div>' + (o.note ? '<p class="omso-note">' + o.note + '</p>' : '') + '</div>';
  }

  function renderOffres(cart) {
    var box = document.querySelector('[data-oms-offres]');
    if (!box) return;
    var ids = META.ids || {}, px = META.prix;
    if (cart.item_count === 0 || !px) { box.hidden = true; box.innerHTML = ''; return; }
    var n = nbFlacons(cart), pack = lignePackUnique(cart), out = [];
    var pu = META.prixUnitaire, pf = META.prixFlaconSeul || 1000;
    var ecoTrio = euros(3 * pu + (META.valeurRacleur || 1490) - px.trio);
    var valTrio = euros(3 * pu + (META.valeurRacleur || 1490));
    var surPack = function (depuis, vers) {
      return (pack && String(pack.variant_id) === String(depuis)) ? 'swap:' + depuis + '|' + vers : 'add:' + ids.flacon;
    };

    if (n === 1) {
      out.push(carteOffre({ kick: 'Complétez votre cure', titre: 'Passez au duo',
        sous: '2ᵉ flacon à ' + euros(pf) + ' au lieu de ' + euros(pu),
        prix: '+ ' + euros(px.duo - px.decouverte), aria: 'Passer au pack duo',
        act: surPack(ids.decouverte, ids.duo) }));
      out.push(carteOffre({ hero: true, kick: '🎁 Débloque le racleur', titre: 'Passez au trio',
        sous: '3 flacons et le racleur offert · ' + valTrio + ' de valeur',
        prix: '+ ' + euros(px.trio - px.decouverte), eco: 'économisez ' + ecoTrio,
        aria: 'Passer au pack trio', act: surPack(ids.decouverte, ids.trio) }));
    } else if (n === 2) {
      out.push(carteOffre({ hero: true, kick: '🎁 Dernier palier', titre: 'Passez au trio',
        sous: 'Le racleur passe à zéro euro',
        prix: '+ ' + euros(px.trio - px.duo), eco: 'économisez ' + ecoTrio,
        aria: 'Passer au pack trio', act: surPack(ids.duo, ids.trio) }));
    } else if (n === 3) {
      out.push(carteOffre({ kick: 'Une dernière chose', titre: 'Un 4ᵉ flacon',
        sous: euros(pf) + ' au lieu de ' + euros(pu) + ' · 4 mois de rituel',
        prix: '+ ' + euros(pf), aria: 'Ajouter un quatrième flacon', act: 'add:' + ids.flacon }));
    }

    /* Le racleur en sortie de secours. Jamais affiché quand il est déjà offert
       (3 flacons) ni quand il est déjà dans le panier : on ne vend pas deux fois. */
    if (!cadeauAcquis(cart) && !aRacleurPaye(cart) && ids.racleur) {
      out.push(carteOffre({ kick: 'Ou juste ceci', titre: 'Le racleur de langue',
        sous: 'Acier inoxydable · le 1ᵉʳ des 3 gestes',
        prix: euros(META.prixRacleur || 990), barre: euros(META.valeurRacleur || 1490),
        img: META.imgRacleur, aria: 'Ajouter le racleur de langue', act: 'add:' + ids.racleur,
        note: (n === 2) ? 'Pour ' + euros(px.trio - px.duo - (META.prixRacleur || 990)) + ' de plus, le trio vous l’offre — et vous avez un flacon en plus.' : null }));
    }
    box.innerHTML = out.join('');
    box.hidden = out.length === 0;
  }

  /* Si le client avait payé le racleur puis atteint 3 flacons, on retire la ligne
     payante. Lui faire payer ce qu'on vient de lui offrir serait indéfendable. */
  var nettoyageEnCours = false;
  function retireRacleurPaye(cart) {
    if (nettoyageEnCours || !cadeauAcquis(cart) || !aRacleurPaye(cart)) return false;
    nettoyageEnCours = true;
    var upd = {}; upd[String(META.ids.racleur)] = 0;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { nettoyageEnCours = false; renderCart(c); })
      .catch(function () { nettoyageEnCours = false; });
    return true;
  }

  function agirOffre(act, btn) {
    var p = act.split(':'), req;
    btn.setAttribute('data-busy', '1');
    if (p[0] === 'swap') {
      var v = p[1].split('|'), upd = {};
      upd[v[0]] = 0; upd[v[1]] = 1;
      req = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) });
    } else {
      req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: p[1], quantity: 1 }) });
    }
    req.then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { btn.removeAttribute('data-busy'); btn.textContent = 'Réessayer'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-oms-act]');
    if (b && !b.getAttribute('data-busy')) agirOffre(b.getAttribute('data-oms-act'), b);
  });

  function renderCart(cart) {
    if (!itemsBox) return;
    if (retireRacleurPaye(cart)) return;
    if (countBadge) {
      countBadge.textContent = cart.item_count;
      countBadge.classList.toggle('hidden', cart.item_count === 0);
      countBadge.classList.toggle('flex', cart.item_count > 0);
    }
    renderJauge(cart);
    /* Lignes */
    if (cart.item_count === 0) {
      itemsBox.innerHTML = '<p class="text-sm text-center px-5 py-10" style="color: rgb(136, 136, 136);">Votre panier est vide.</p>';
    } else {
      itemsBox.innerHTML = cart.items.map(function (item) {
        var meta = META.variants[String(item.variant_id)] || {};
        var title = meta.title || item.product_title;
        var sub = meta.sub || item.variant_title || '';
        var compareHtml = meta.compare ? '<span class="text-[13px] line-through" style="color: rgb(187, 187, 187);">' + meta.compare + '</span>' : '';
        var pctHtml = meta.pct ? '<span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full" style="background-color: rgb(240, 235, 255); color: rgb(123, 79, 212);">' + meta.pct + '</span>' : '';
        return '<div class="flex items-start gap-3 px-5 py-4" style="border-bottom: 1px solid rgb(240, 235, 255);">' +
          '<img src="' + item.image + '" alt="" class="w-20 h-20 rounded-lg object-cover shrink-0">' +
          '<div class="flex-1 min-w-0">' +
          '<p class="text-sm font-medium truncate" style="color: rgb(26, 26, 26);">' + title + '</p>' +
          '<p class="text-xs mt-0.5" style="color: rgb(136, 136, 136);">' + sub + '</p>' +
          '<div class="flex items-center gap-2 mt-1.5">' + compareHtml +
          '<span class="text-base font-bold" style="color: rgb(123, 79, 212);">' + euros(item.final_line_price) + '</span>' + pctHtml + '</div>' +
          '<div class="flex items-center justify-between mt-2">' +
          '<div class="flex items-center gap-1.5">' +
          '<button data-oms-qty="' + item.key + '|' + (item.quantity - 1) + '" class="w-7 h-7 rounded-full flex items-center justify-center transition-colors disabled:opacity-50" style="border: 1px solid rgb(232, 222, 255);"><svg class="h-3 w-3"><use href="#ic-minus"/></svg></button>' +
          '<span class="text-sm font-medium w-6 text-center">' + item.quantity + '</span>' +
          '<button data-oms-qty="' + item.key + '|' + (item.quantity + 1) + '" class="w-7 h-7 rounded-full flex items-center justify-center transition-colors disabled:opacity-50" style="border: 1px solid rgb(232, 222, 255);"><svg class="h-3 w-3"><use href="#ic-plus"/></svg></button>' +
          '</div>' +
          '<button data-oms-qty="' + item.key + '|0" class="text-[11px] transition-colors disabled:opacity-50" style="color: rgb(239, 68, 68);">Retirer</button>' +
          '</div></div></div>';
      }).join('');
      /* Cadeau racleur : 3 flacons ou plus, quel que soit le chemin */
      if (META.gift && cadeauAcquis(cart)) {
        itemsBox.innerHTML += '<div class="flex items-start gap-3 px-5 py-4" style="border-bottom: 1px solid rgb(240, 235, 255); background-color: rgb(247, 243, 255);">' +
          /* 🔴 12/09/2026 : c'était un emoji 🎁 dans un carré violet. Le client voyait
             un pictogramme là où toutes les autres lignes du panier montrent le produit :
             le cadeau avait l'air d'une promesse abstraite, pas d'un objet qu'on reçoit.
             On met le vrai packshot. `object-fit:contain` sur fond blanc et non `cover` :
             le racleur est un objet portrait très allongé, un recadrage carré en `cover`
             ne garderait que le milieu du manche et perdrait la boucle, sa seule partie
             reconnaissable. `contain` est écrit en style inline parce que la classe
             Tailwind correspondante n'existe pas dans le build compilé du thème.
             Repli sur l'ancienne pastille si le produit racleur n'est pas publié :
             une image cassée serait pire que le pictogramme. */
          (META.imgRacleur
            ? '<img src="' + META.imgRacleur + '" alt="" class="w-20 h-20 rounded-lg shrink-0" style="object-fit:contain;background-color:#fff;border:1px solid rgb(240,235,255);">'
            : '<div class="w-20 h-20 rounded-lg shrink-0 flex items-center justify-center text-3xl" style="background-color: rgb(240, 235, 255);">🎁</div>') +
          '<div class="flex-1 min-w-0">' +
          '<p class="text-sm font-medium" style="color: rgb(26, 26, 26);">' + META.gift.title + '</p>' +
          '<p class="text-xs mt-0.5" style="color: rgb(136, 136, 136);">' + META.gift.sub + '</p>' +
          '<div class="flex items-center gap-2 mt-1.5">' +
          '<span class="text-[13px] line-through" style="color: rgb(187, 187, 187);">' + META.gift.value + '</span>' +
          '<span class="text-[11px] font-bold px-2 py-0.5 rounded-full" style="background-color: rgb(220, 252, 231); color: rgb(22, 163, 74);">' + META.gift.badge + '</span>' +
          '</div></div></div>';
      }
      itemsBox.querySelectorAll('[data-oms-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var parts = btn.getAttribute('data-oms-qty').split('|');
          btn.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parts[0], quantity: Math.max(0, parseInt(parts[1], 10)) })
          }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { btn.disabled = false; });
        });
      });
    }
    /* Total */
    if (totalEl) totalEl.textContent = euros(cart.total_price);
    if (compareEl) {
      var compareTotal = cart.items.reduce(function (acc, item) {
        var meta = META.variants[String(item.variant_id)] || {};
        if (meta.compare) {
          var c = parseFloat(meta.compare.replace(',', '.')) * 100;
          return acc + c * item.quantity;
        }
        return acc + item.final_line_price;
      }, 0);
      compareEl.textContent = (compareTotal > cart.total_price) ? euros(compareTotal) : '';
    }
    renderOffres(cart);
  }

  function refreshCart(open) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      if (open) openDrawer();
    });
  }
  refreshCart(false);

  var checkoutBtn = document.querySelector('[data-oms-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

  document.querySelectorAll('[data-oms-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
  });

  /* ---------- Ajout panier ---------- */
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var p = PACKS[current];
      if (!p) return;
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Ajout en cours…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.variant, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = '🛒 AJOUTER · ' + p.price;
        refreshCart(true);
      }).catch(function () {
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = '🛒 AJOUTER · ' + p.price;
      });
    });
  }

  /* ---------- Rotateur de témoignages ---------- */
  var quotes = document.querySelectorAll('[data-oms-quote]');
  if (quotes.length > 1) {
    var qi = 0;
    setInterval(function () {
      qi = (qi + 1) % quotes.length;
      quotes.forEach(function (q, j) {
        if (j === qi) {
          q.style.position = 'relative'; q.style.pointerEvents = 'auto'; q.style.opacity = '1';
        } else {
          q.style.position = 'absolute'; q.style.pointerEvents = 'none'; q.style.opacity = '0';
          q.style.top = '0'; q.style.left = '0'; q.style.right = '0';
        }
      });
    }, 4200);
  }

  /* ---------- Compteurs animés ---------- */
  var counters = document.querySelectorAll('[data-oms-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.getAttribute('data-oms-count'), 10);
        var prefix = el.getAttribute('data-prefix') || '';
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var pr = Math.min((ts - start) / 1600, 1);
          var val = Math.round(target * (1 - Math.pow(1 - pr, 3)));
          el.textContent = prefix + val.toLocaleString('fr-FR').replace(/ /g, ' ') + suffix;
          if (pr < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { io.observe(c); });
  }

  /* ---------- Slider avant / après ---------- */
  var ba = document.querySelector('[data-oms-ba]');
  if (ba) {
    var beforeImg = ba.querySelector('[data-oms-ba-before]');
    var bar = ba.querySelector('[data-oms-ba-bar]');
    function setPos(clientX) {
      var rect = ba.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      beforeImg.style.clipPath = 'inset(0px ' + (100 - pct) + '% 0px 0px)';
      bar.style.left = pct + '%';
    }
    var dragging = false;
    ba.addEventListener('pointerdown', function (e) { dragging = true; ba.setPointerCapture(e.pointerId); setPos(e.clientX); });
    ba.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    ba.addEventListener('pointerup', function () { dragging = false; });
    ba.addEventListener('pointercancel', function () { dragging = false; });
  }
})();
